// import React, { useEffect, useState } from "react";
// import { Outlet, NavLink, useNavigate, useLocation } from "react-router-dom";
// import {
//   AppBar,
//   Box,
//   CssBaseline,
//   Drawer,
//   IconButton,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Toolbar,
//   Typography,
//   Button,
//   Avatar,
//   Divider,
// } from "@mui/material";
// import logo from "./logo.png";
// import MenuIcon from "@mui/icons-material/Menu";
// import LogoutIcon from "@mui/icons-material/Logout";
// import {
//   LayoutDashboard,
//   Users,
//   CalendarDays,
//   Bell,
//   ShieldCheck,
//   Scale,
//   FileBarChart
// } from "lucide-react";

// const drawerWidth = 260;

// const hideScrollbar = {
//   msOverflowStyle: "none",
//   scrollbarWidth: "none",
//   "&::-webkit-scrollbar": { display: "none" },
// };

// // ✅ STAFF SIDEBAR (only 3 menus)
// const sidebarItems = [
//   {
//     section: "STAFF MODULES",
//     items: [
//       {
//         title: "Dashboard",
//         href: "/staff/dashboard2",
//         icon: <LayoutDashboard size={18} />,
//       },
//       {
//         title: "Customers",
//         href: "/staff/customers",
//         icon: <Users size={18} />,
//       },
//       {
//         title: "Payments",
//         href: "/staff/payments",
//         icon: <CalendarDays size={18} />,
//       },
//       {
//         title: "Notes",
//         href: "/staff/notes",
//         icon: <ShieldCheck size={18} />,
//       },
//       {
//         title: "List",
//         href: "/staff/list",
//         icon: <Users size={18} />,
//       },

//       {
//         title: "Advanced",
//         href: "/staff/advance",
//         icon: <Scale size={18} />,
//       },
//       {
//         title: "Original Amount",
//         href: "/staff/original",
//         icon: <CalendarDays size={18} />,
//       },

//       {
//         title: "pending customers",
//         href: "/staff/pending",
//         icon: <ShieldCheck size={18} />,
//       },

//       {
//         title: "Closed customer",
//         href: "/staff/closed",
//         icon: <ShieldCheck size={18} />,
//       },
//       {
//         title: "Expenses",
//         href: "/staff/expenses",
//         icon: <FileBarChart size={18} />,
//       },
//     ],
//   },
// ];

// export default function StaffLayout() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [username, setUsername] = useState("Staff");

//   useEffect(() => {
//     const currentUser = JSON.parse(localStorage.getItem("currentUser"));

//     // ✅ Staff Auth Guard
//     if (!currentUser || currentUser.role !== "staff") {
//       navigate("/", { replace: true });
//     } else {
//       setUsername(currentUser.username || "Staff");
//     }

//     // ✅ Prevent Back Navigation (same as admin)
//     window.history.pushState(null, null, window.location.href);
//     const handlePopState = () => {
//       window.history.pushState(null, null, window.location.href);
//     };

//     window.addEventListener("popstate", handlePopState);
//     return () => window.removeEventListener("popstate", handlePopState);
//   }, [navigate]);

//   const handleLogout = () => {
//     localStorage.removeItem("currentUser");
//     navigate("/", { replace: true });
//   };

//   const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

//   // ✅ COPY FROM ADMIN LAYOUT (UI SAME)
//   const drawer = (
//     <Box
//       sx={{
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//         bgcolor: "#0f172a",
//         color: "#f8fafc",
//       }}
//     >
//       <Toolbar sx={{ px: 3 }}>
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//             <Box
//             component="img"
//             src={logo}
//             alt="SAL Finance Logo"
//             sx={{
//               width: 52,
//               height: 52,
//               objectFit: "contain",
//               borderRadius: 1,
//             }}
//           />
//           <Typography
//             sx={{
//               fontWeight: 800,
//               fontSize: "1.1rem",
//               letterSpacing: "-0.5px",
//               fontFamily: "'Inter', sans-serif",
//             }}
//           >
//             Staff<span style={{ color: "#3b82f6" }}>ERP</span>
//           </Typography>
//         </Box>
//       </Toolbar>

//       <Box sx={{ flex: 1, px: 2, py: 3, overflowY: "auto", ...hideScrollbar }}>
//         {sidebarItems.map((group) => (
//           <Box key={group.section} sx={{ mb: 3 }}>
//             <Typography
//               sx={{
//                 fontSize: "10px",
//                 color: "#64748b",
//                 fontWeight: 700,
//                 mb: 1.5,
//                 ml: 2,
//                 letterSpacing: "1.2px",
//               }}
//             >
//               {group.section}
//             </Typography>

//             <List sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
//               {group.items.map((item) => (
//                 <ListItem key={item.href} disablePadding>
//                   <ListItemButton
//                     component={NavLink}
//                     to={item.href}
//                     sx={{
//                       borderRadius: "8px",
//                       py: 1,
//                       px: 2,
//                       color: "#94a3b8",
//                       transition: "0.2s",
//                       "&.active": {
//                         bgcolor: "rgba(59, 130, 246, 0.1)",
//                         color: "#3b82f6",
//                         "& .MuiListItemIcon-root": { color: "#3b82f6" },
//                       },
//                       "&:hover": {
//                         bgcolor: "rgba(255,255,255,0.03)",
//                         color: "#f8fafc",
//                       },
//                     }}
//                   >
//                     <ListItemIcon sx={{ color: "inherit", minWidth: 32 }}>
//                       {item.icon}
//                     </ListItemIcon>
//                     <ListItemText
//                       primary={item.title}
//                       primaryTypographyProps={{
//                         fontSize: "13.5px",
//                         fontWeight: 500,
//                         fontFamily: "'Inter', sans-serif",
//                       }}
//                     />
//                   </ListItemButton>
//                 </ListItem>
//               ))}
//             </List>
//           </Box>
//         ))}
//       </Box>

//       <Box sx={{ p: 2, borderTop: "1px solid rgba(255,255,255,0.05)" }}>
//         <Button
//           fullWidth
//           startIcon={<LogoutIcon size={18} />}
//           onClick={handleLogout}
//           sx={{
//             color: "#f1f5f9",
//             justifyContent: "flex-start",
//             textTransform: "none",
//             borderRadius: "8px",
//             py: 1.2,
//             px: 2,
//             fontSize: "13.5px",
//             fontWeight: 500,
//             fontFamily: "'Inter', sans-serif",
//             "&:hover": { bgcolor: "rgba(239, 68, 68, 0.1)", color: "#ef4444" },
//           }}
//         >
//           Logout Session
//         </Button>
//       </Box>
//     </Box>
//   );

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         bgcolor: "#f1f5f9",
//         minHeight: "100vh",
//         fontFamily: "'Inter', sans-serif",
//       }}
//     >
//       <CssBaseline />

//       {/* ✅ TOP BAR SAME AS ADMIN */}
//       <AppBar
//         position="fixed"
//         elevation={0}
//         sx={{
//           width: { sm: `calc(100% - ${drawerWidth}px)` },
//           ml: { sm: `${drawerWidth}px` },
//           bgcolor: "rgba(255, 255, 255, 0.8)",
//           backdropFilter: "blur(8px)",
//           borderBottom: "1px solid #e2e8f0",
//           color: "#1e293b",
//         }}
//       >
//         <Toolbar sx={{ justifyContent: "space-between", minHeight: "64px" }}>
//           <Box sx={{ display: "flex", alignItems: "center" }}>
//             <IconButton
//               color="inherit"
//               edge="start"
//               onClick={handleDrawerToggle}
//               sx={{ mr: 2, display: { sm: "none" } }}
//             >
//               <MenuIcon />
//             </IconButton>
//             <Typography
//               sx={{
//                 fontSize: "14px",
//                 fontWeight: 600,
//                 color: "#64748b",
//                 textTransform: "capitalize",
//               }}
//             >
//               {location.pathname.split("/").pop().replace("-", " ")}
//             </Typography>
//           </Box>

//           <Box sx={{ display: "flex", alignItems: "center", gap: 2.5 }}>
//             <IconButton size="small" sx={{ color: "#64748b" }}>
//               <Bell size={20} />
//             </IconButton>

//             <Divider orientation="vertical" flexItem sx={{ my: 2 }} />

//             <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//               <Box
//                 sx={{
//                   textAlign: "right",
//                   display: { xs: "none", md: "block" },
//                 }}
//               >
//                 <Typography
//                   sx={{ fontSize: "13px", fontWeight: 700, lineHeight: 1 }}
//                 >
//                   {username}
//                 </Typography>
//                 <Typography
//                   sx={{ fontSize: "11px", color: "#3b82f6", fontWeight: 600 }}
//                 >
//                   Staff User
//                 </Typography>
//               </Box>
//               <Avatar
//                 sx={{
//                   width: 36,
//                   height: 36,
//                   bgcolor: "#3b82f6",
//                   fontSize: "14px",
//                   fontWeight: 700,
//                   border: "2px solid #fff",
//                   boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//                 }}
//               >
//                 {username.charAt(0).toUpperCase()}
//               </Avatar>
//             </Box>
//           </Box>
//         </Toolbar>
//       </AppBar>

//       {/* ✅ SIDEBAR SAME AS ADMIN */}
//       <Box
//         component="nav"
//         sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
//       >
//         <Drawer
//           variant="temporary"
//           open={mobileOpen}
//           onClose={handleDrawerToggle}
//           ModalProps={{ keepMounted: true }}
//           sx={{
//             display: { xs: "block", sm: "none" },
//             "& .MuiDrawer-paper": {
//               width: drawerWidth,
//               boxSizing: "border-box",
//               border: "none",
//             },
//           }}
//         >
//           {drawer}
//         </Drawer>

//         <Drawer
//           variant="permanent"
//           sx={{
//             display: { xs: "none", sm: "block" },
//             "& .MuiDrawer-paper": {
//               width: drawerWidth,
//               boxSizing: "border-box",
//               border: "none",
//               ...hideScrollbar,
//             },
//           }}
//           open
//         >
//           {drawer}
//         </Drawer>
//       </Box>

//       {/* ✅ CONTENT */}
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: { xs: 3, sm: 5 },
//           width: { xs: "100%", sm: `calc(100% - ${drawerWidth}px)` },
//           mt: "64px",
//         }}
//       >
//         <Outlet />
//       </Box>
//     </Box>
//   );
// }

// import React, { useEffect, useState } from "react";
// import { Outlet, NavLink, useNavigate, useLocation } from "react-router-dom";
// import {
//   AppBar,
//   Box,
//   CssBaseline,
//   Drawer,
//   IconButton,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Toolbar,
//   Typography,
//   Button,
//   Avatar,
//   Divider,
//   useTheme,
//   useMediaQuery,
// } from "@mui/material";
// import logo from "./logo.png";
// import MenuIcon from "@mui/icons-material/Menu";
// import LogoutIcon from "@mui/icons-material/Logout";
// import {
//   LayoutDashboard,
//   Users,
//   CalendarDays,
//   Bell,
//   ShieldCheck,
//   Scale,
//   FileBarChart,
// } from "lucide-react";

// const drawerWidth = 260;
// const collapsedWidth = 85; // Width for icons-only mode

// const hideScrollbar = {
//   msOverflowStyle: "none",
//   scrollbarWidth: "none",
//   "&::-webkit-scrollbar": { display: "none" },
// };

// const sidebarItems = [
//   {
//     section: "STAFF MODULES",
//     items: [
//       {
//         title: "Dashboard",
//         href: "/staff/dashboard2",
//         icon: <LayoutDashboard size={18} />,
//       },
//       {
//         title: "Customers",
//         href: "/staff/customers",
//         icon: <Users size={18} />,
//       },
//       {
//         title: "Payments",
//         href: "/staff/payments",
//         icon: <CalendarDays size={18} />,
//       },
//       { title: "Notes", href: "/staff/notes", icon: <ShieldCheck size={18} /> },
//       { title: "List", href: "/staff/list", icon: <Users size={18} /> },
//       { title: "Advanced", href: "/staff/advance", icon: <Scale size={18} /> },
//       {
//         title: "Original Amount",
//         href: "/staff/original",
//         icon: <CalendarDays size={18} />,
//       },
//       {
//         title: "pending customers",
//         href: "/staff/pending",
//         icon: <ShieldCheck size={18} />,
//       },
//       {
//         title: "Closed customer",
//         href: "/staff/closed",
//         icon: <ShieldCheck size={18} />,
//       },
//       {
//         title: "Expenses",
//         href: "/staff/expenses",
//         icon: <FileBarChart size={18} />,
//       },
//     ],
//   },
// ];

// export default function StaffLayout() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [isCollapsed, setIsCollapsed] = useState(false); // Desktop toggle state
//   const [username, setUsername] = useState("Staff");

//   useEffect(() => {
//     const currentUser = JSON.parse(localStorage.getItem("currentUser"));
//     if (!currentUser || currentUser.role !== "staff") {
//       navigate("/", { replace: true });
//     } else {
//       setUsername(currentUser.username || "Staff");
//     }

//     window.history.pushState(null, null, window.location.href);
//     const handlePopState = () =>
//       window.history.pushState(null, null, window.location.href);
//     window.addEventListener("popstate", handlePopState);
//     return () => window.removeEventListener("popstate", handlePopState);
//   }, [navigate]);

//   const handleLogout = () => {
//     localStorage.removeItem("currentUser");
//     navigate("/", { replace: true });
//   };

//   const handleDrawerToggle = () => {
//     if (isMobile) {
//       setMobileOpen(!mobileOpen);
//     } else {
//       setIsCollapsed(!isCollapsed);
//     }
//   };

//   const currentWidth = isMobile
//     ? drawerWidth
//     : isCollapsed
//       ? collapsedWidth
//       : drawerWidth;

//   const drawer = (
//     <Box
//       sx={{
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//         bgcolor: "#0f172a",
//         color: "#f8fafc",
//       }}
//     >
//       <Toolbar sx={{ px: isCollapsed && !isMobile ? 2 : 3 }}>
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//           <Box
//             component="img"
//             src={logo}
//             alt="Logo"
//             sx={{
//               width: 45,
//               height: 45,
//               objectFit: "contain",
//               borderRadius: 1,
//             }}
//           />
//           {(!isCollapsed || isMobile) && (
//             <Typography
//               sx={{
//                 fontWeight: 800,
//                 fontSize: "1.1rem",
//                 letterSpacing: "-0.5px",
//                 fontFamily: "'Inter', sans-serif",
//               }}
//             >
//               Staff<span style={{ color: "#3b82f6" }}>ERP</span>
//             </Typography>
//           )}
//         </Box>
//       </Toolbar>

//       <Box sx={{ flex: 1, px: 2, py: 3, overflowY: "auto", ...hideScrollbar }}>
//         {sidebarItems.map((group) => (
//           <Box key={group.section} sx={{ mb: 3 }}>
//             {(!isCollapsed || isMobile) && (
//               <Typography
//                 sx={{
//                   fontSize: "10px",
//                   color: "#64748b",
//                   fontWeight: 700,
//                   mb: 1.5,
//                   ml: 2,
//                   letterSpacing: "1.2px",
//                   fontFamily: "'Inter', sans-serif",
//                 }}
//               >
//                 {group.section}
//               </Typography>
//             )}

//             <List sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
//               {group.items.map((item) => (
//                 <ListItem key={item.href} disablePadding>
//                   <ListItemButton
//                     component={NavLink}
//                     to={item.href}
//                     onClick={() => isMobile && setMobileOpen(false)} // ✅ Auto-close on mobile
//                     sx={{
//                       borderRadius: "8px",
//                       py: 1,
//                       px: isCollapsed && !isMobile ? 1.5 : 2,
//                       justifyContent:
//                         isCollapsed && !isMobile ? "center" : "flex-start",
//                       color: "#94a3b8",
//                       "&.active": {
//                         bgcolor: "rgba(59, 130, 246, 0.1)",
//                         color: "#3b82f6",
//                         "& .MuiListItemIcon-root": { color: "#3b82f6" },
//                       },
//                       "&:hover": {
//                         bgcolor: "rgba(255,255,255,0.03)",
//                         color: "#f8fafc",
//                       },
//                     }}
//                   >
//                     <ListItemIcon
//                       sx={{
//                         color: "inherit",
//                         minWidth: isCollapsed && !isMobile ? 0 : 32,
//                       }}
//                     >
//                       {item.icon}
//                     </ListItemIcon>
//                     {(!isCollapsed || isMobile) && (
//                       <ListItemText
//                         primary={item.title}
//                         primaryTypographyProps={{
//                           fontSize: "13.5px",
//                           fontWeight: 500,
//                           fontFamily: "'Inter', sans-serif",
//                         }}
//                       />
//                     )}
//                   </ListItemButton>
//                 </ListItem>
//               ))}
//             </List>
//           </Box>
//         ))}
//       </Box>

//       <Box sx={{ p: 2, borderTop: "1px solid rgba(255,255,255,0.05)" }}>
//         <Button
//           fullWidth
//           startIcon={<LogoutIcon size={18} />}
//           onClick={handleLogout}
//           sx={{
//             color: "#f1f5f9",
//             justifyContent: isCollapsed && !isMobile ? "center" : "flex-start",
//             textTransform: "none",
//             borderRadius: "8px",
//             py: 1.2,
//             px: 2,
//             fontSize: "13.5px",
//             fontWeight: 500,
//             fontFamily: "'Inter', sans-serif",
//             "& .MuiButton-startIcon": { mr: isCollapsed && !isMobile ? 0 : 1 },
//             "&:hover": { bgcolor: "rgba(239, 68, 68, 0.1)", color: "#ef4444" },
//           }}
//         >
//           {(!isCollapsed || isMobile) && "Logout Session"}
//         </Button>
//       </Box>
//     </Box>
//   );

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         bgcolor: "#f1f5f9",
//         minHeight: "100vh",
//         fontFamily: "'Inter', sans-serif",
//       }}
//     >
//       <CssBaseline />

//       <AppBar
//         position="fixed"
//         elevation={0}
//         sx={{
//           width: { sm: `calc(100% - ${currentWidth}px)` },
//           ml: { sm: `${currentWidth}px` },
//           bgcolor: "rgba(255, 255, 255, 0.8)",
//           backdropFilter: "blur(8px)",
//           borderBottom: "1px solid #e2e8f0",
//           color: "#1e293b",
//           transition: theme.transitions.create(["width", "margin"], {
//             duration: 300,
//           }),
//         }}
//       >
//         <Toolbar sx={{ justifyContent: "space-between", minHeight: "64px" }}>
//           <Box sx={{ display: "flex", alignItems: "center" }}>
//             <IconButton
//               color="inherit"
//               edge="start"
//               onClick={handleDrawerToggle}
//               sx={{ mr: 2 }}
//             >
//               <MenuIcon />
//             </IconButton>
//             <Typography
//               sx={{
//                 fontSize: "14px",
//                 fontWeight: 600,
//                 color: "#64748b",
//                 textTransform: "capitalize",
//                 fontFamily: "'Inter', sans-serif",
//               }}
//             >
//               {location.pathname.split("/").pop().replace("-", " ")}
//             </Typography>
//           </Box>

//           {/* ... User profile section ... */}
//           <Box sx={{ display: "flex", alignItems: "center", gap: 2.5 }}>
//             <IconButton size="small" sx={{ color: "#64748b" }}>
//               <Bell size={20} />
//             </IconButton>
//             <Divider orientation="vertical" flexItem sx={{ my: 2 }} />
//             <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//               <Box
//                 sx={{
//                   textAlign: "right",
//                   display: { xs: "none", md: "block" },
//                 }}
//               >
//                 <Typography
//                   sx={{
//                     fontSize: "13px",
//                     fontWeight: 700,
//                     lineHeight: 1,
//                     fontFamily: "'Inter', sans-serif",
//                   }}
//                 >
//                   {username}
//                 </Typography>
//                 <Typography
//                   sx={{
//                     fontSize: "11px",
//                     color: "#3b82f6",
//                     fontWeight: 600,
//                     fontFamily: "'Inter', sans-serif",
//                   }}
//                 >
//                   Staff User
//                 </Typography>
//               </Box>
//               <Avatar
//                 sx={{
//                   width: 36,
//                   height: 36,
//                   bgcolor: "#3b82f6",
//                   fontSize: "14px",
//                   fontWeight: 700,
//                   border: "2px solid #fff",
//                   boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//                 }}
//               >
//                 {username.charAt(0).toUpperCase()}
//               </Avatar>
//             </Box>
//           </Box>
//         </Toolbar>
//       </AppBar>

//       <Box
//         component="nav"
//         sx={{
//           width: { sm: currentWidth },
//           flexShrink: { sm: 0 },
//           transition: "width 0.3s",
//         }}
//       >
//         <Drawer
//           variant="temporary"
//           open={mobileOpen}
//           onClose={handleDrawerToggle}
//           ModalProps={{ keepMounted: true }}
//           sx={{
//             display: { xs: "block", sm: "none" },
//             "& .MuiDrawer-paper": {
//               width: drawerWidth,
//               boxSizing: "border-box",
//               border: "none",
//             },
//           }}
//         >
//           {drawer}
//         </Drawer>

//         <Drawer
//           variant="permanent"
//           sx={{
//             display: { xs: "none", sm: "block" },
//             "& .MuiDrawer-paper": {
//               width: currentWidth,
//               boxSizing: "border-box",
//               border: "none",
//               transition: "width 0.3s",
//               overflowX: "hidden",
//               ...hideScrollbar,
//             },
//           }}
//           open
//         >
//           {drawer}
//         </Drawer>
//       </Box>

//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: { xs: 3, sm: 5 },
//           width: { xs: "100%", sm: `calc(100% - ${currentWidth}px)` },
//           mt: "64px",
//           transition: "margin 0.3s, width 0.3s",
//         }}
//       >
//         <Outlet />
//       </Box>
//     </Box>
//   );
// }

// import React, { useEffect, useState } from "react";
// import { Outlet, NavLink, useNavigate, useLocation } from "react-router-dom";
// import {
//   AppBar,
//   Box,
//   CssBaseline,
//   Drawer,
//   IconButton,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Toolbar,
//   Typography,
//   Button,
//   Avatar,
//   Divider,
//   useTheme,
//   useMediaQuery,
// } from "@mui/material";
// import logo from "./logo.png";
// import MenuIcon from "@mui/icons-material/Menu";
// import LogoutIcon from "@mui/icons-material/Logout";
// import {
//   LayoutDashboard,
//   Users,
//   UserPlus,
//   UserCheck,
//   UserX,
//   Contact2,
//   Wallet,
//   HandCoins,
//   BadgeDollarSign,
//   Receipt,
//   StickyNote,
//   Bell,
// } from "lucide-react";

// const drawerWidth = 260;
// const collapsedWidth = 85;

// const visibleScrollbar = {
//   overflowY: "auto",

//   "&::-webkit-scrollbar": {
//     width: "6px",
//   },
//   "&::-webkit-scrollbar-track": {
//     background: "transparent",
//   },
//   "&::-webkit-scrollbar-thumb": {
//     backgroundColor: "rgba(148,163,184,0.4)", // slate-400
//     borderRadius: "8px",
//   },
//   "&::-webkit-scrollbar-thumb:hover": {
//     backgroundColor: "rgba(148,163,184,0.7)",
//   },

//   scrollbarWidth: "thin", // Firefox
//   scrollbarColor: "rgba(148,163,184,0.6) transparent",
// };

// // Logically grouped sidebar items for Staff
// const sidebarItems = [
//   {
//     section: "OVERVIEW",
//     items: [
//       {
//         title: "Dashboard",
//         href: "/staff/dashboard2",
//         icon: <LayoutDashboard size={18} />,
//       },
//       {
//         title: "Master List",
//         href: "/staff/list",
//         icon: <Contact2 size={18} />,
//       },
//     ],
//   },
//   {
//     section: "USER MANAGEMENT",
//     items: [
//       {
//         title: "Active Customers",
//         href: "/staff/customers",
//         icon: <UserCheck size={18} />,
//       },
//       {
//         title: "Pending",
//         href: "/staff/pending",
//         icon: <UserPlus size={18} />,
//       },
//       {
//         title: "Closed Accounts",
//         href: "/staff/closed",
//         icon: <UserX size={18} />,
//       },
//       {
//         title: "Staff Notes",
//         href: "/staff/notes",
//         icon: <StickyNote size={18} />,
//       },
//     ],
//   },
//   {
//     section: "FINANCIALS",
//     items: [
//       {
//         title: "Payments",
//         href: "/staff/payments",
//         icon: <Wallet size={18} />,
//       },
//       {
//         title: "Advance Given",
//         href: "/staff/advance",
//         icon: <HandCoins size={18} />,
//       },
//       {
//         title: "Principal Amount",
//         href: "/staff/original",
//         icon: <BadgeDollarSign size={18} />,
//       },
//       {
//         title: "Daily Expenses",
//         href: "/staff/expenses",
//         icon: <Receipt size={18} />,
//       },
//     ],
//   },
// ];

// export default function StaffLayout() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [isCollapsed, setIsCollapsed] = useState(false);
//   const [username, setUsername] = useState("Staff");

//   useEffect(() => {
//     const currentUser = JSON.parse(localStorage.getItem("currentUser"));
//     if (!currentUser || currentUser.role !== "staff") {
//       navigate("/", { replace: true });
//     } else {
//       setUsername(currentUser.username || "Staff");
//     }

//   }, [navigate]);

//    useEffect(() => {
//       const currentUser = JSON.parse(localStorage.getItem("currentUser"));

//       if (!currentUser || currentUser.role !== "staff") {
//         navigate("/", { replace: true }); // only for auth redirect
//       } else {
//         setUsername(currentUser.username || "Admin");
//       }
//     }, [navigate]);

//   const handleLogout = () => {
//     localStorage.removeItem("currentUser");
//     navigate("/", { replace: true });
//   };

//   const handleDrawerToggle = () => {
//     if (isMobile) {
//       setMobileOpen(!mobileOpen);
//     } else {
//       setIsCollapsed(!isCollapsed);
//     }
//   };

//   const currentWidth = isMobile
//     ? drawerWidth
//     : isCollapsed
//       ? collapsedWidth
//       : drawerWidth;

//   const drawer = (
//     <Box
//       sx={{
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//         bgcolor: "#0f172a",
//         color: "#f8fafc",
//       }}
//     >
//       <Toolbar sx={{ px: isCollapsed && !isMobile ? 2 : 3 }}>
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//           <Box
//             component="img"
//             src={logo}
//             alt="Logo"
//             sx={{
//               width: 45,
//               height: 45,
//               objectFit: "contain",
//               borderRadius: 1,
//             }}
//           />
//           {(!isCollapsed || isMobile) && (
//             <Typography
//               sx={{
//                 fontWeight: 800,
//                 fontSize: "1.1rem",
//                 letterSpacing: "-0.5px",
//                 fontFamily: "'Inter', sans-serif",
//               }}
//             >
//               Staff<span style={{ color: "#3b82f6" }}>ERP</span>
//             </Typography>
//           )}
//         </Box>
//       </Toolbar>

//       {/* <Box sx={{ flex: 1, px: 2, py: 3, overflowY: "auto", ...hideScrollbar }}> */}
//       <Box sx={{ flex: 1, px: 2, py: 3, ...visibleScrollbar }}>
//         {sidebarItems.map((group) => (
//           <Box key={group.section} sx={{ mb: 3 }}>
//             {(!isCollapsed || isMobile) && (
//               <Typography
//                 sx={{
//                   fontSize: "10px",
//                   color: "#64748b",
//                   fontWeight: 700,
//                   mb: 1.5,
//                   ml: 2,
//                   letterSpacing: "1.2px",
//                   fontFamily: "'Inter', sans-serif",
//                   textTransform: "uppercase",
//                 }}
//               >
//                 {group.section}
//               </Typography>
//             )}

//             <List sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
//               {group.items.map((item) => (
//                 <ListItem key={item.href} disablePadding>
//                   <ListItemButton
//                     component={NavLink}
//                     to={item.href}
//                     onClick={() => isMobile && setMobileOpen(false)}
//                     sx={{
//                       borderRadius: "8px",
//                       py: 1,
//                       px: isCollapsed && !isMobile ? 1.5 : 2,
//                       justifyContent:
//                         isCollapsed && !isMobile ? "center" : "flex-start",
//                       color: "#94a3b8",
//                       "&.active": {
//                         bgcolor: "rgba(59, 130, 246, 0.1)",
//                         color: "#3b82f6",
//                         "& .MuiListItemIcon-root": { color: "#3b82f6" },
//                       },
//                       "&:hover": {
//                         bgcolor: "rgba(255,255,255,0.03)",
//                         color: "#f8fafc",
//                       },
//                     }}
//                   >
//                     <ListItemIcon
//                       sx={{
//                         color: "inherit",
//                         minWidth: isCollapsed && !isMobile ? 0 : 32,
//                       }}
//                     >
//                       {item.icon}
//                     </ListItemIcon>
//                     {(!isCollapsed || isMobile) && (
//                       <ListItemText
//                         primary={item.title}
//                         primaryTypographyProps={{
//                           fontSize: "13.5px",
//                           fontWeight: 500,
//                           fontFamily: "'Inter', sans-serif",
//                         }}
//                       />
//                     )}
//                   </ListItemButton>
//                 </ListItem>
//               ))}
//             </List>
//           </Box>
//         ))}
//       </Box>

//       <Box sx={{ p: 2, borderTop: "1px solid rgba(255,255,255,0.05)" }}>
//         <Button
//           fullWidth
//           startIcon={<LogoutIcon size={18} />}
//           onClick={handleLogout}
//           sx={{
//             color: "#f1f5f9",
//             justifyContent: isCollapsed && !isMobile ? "center" : "flex-start",
//             textTransform: "none",
//             borderRadius: "8px",
//             py: 1.2,
//             px: 2,
//             fontSize: "13.5px",
//             fontWeight: 500,
//             fontFamily: "'Inter', sans-serif",
//             "& .MuiButton-startIcon": { mr: isCollapsed && !isMobile ? 0 : 1 },
//             "&:hover": { bgcolor: "rgba(239, 68, 68, 0.1)", color: "#ef4444" },
//           }}
//         >
//           {(!isCollapsed || isMobile) && "Logout Session"}
//         </Button>
//       </Box>
//     </Box>
//   );

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         bgcolor: "#f1f5f9",
//         minHeight: "100vh",
//         fontFamily: "'Inter', sans-serif",
//       }}
//     >
//       <CssBaseline />

//       <AppBar
//         position="fixed"
//         elevation={0}
//         sx={{
//           width: { sm: `calc(100% - ${currentWidth}px)` },
//           ml: { sm: `${currentWidth}px` },
//           bgcolor: "rgba(255, 255, 255, 0.8)",
//           backdropFilter: "blur(8px)",
//           borderBottom: "1px solid #e2e8f0",
//           color: "#1e293b",
//           transition: theme.transitions.create(["width", "margin"], {
//             duration: 300,
//           }),
//         }}
//       >
//         <Toolbar sx={{ justifyContent: "space-between", minHeight: "64px" }}>
//           <Box sx={{ display: "flex", alignItems: "center" }}>
//             <IconButton
//               color="inherit"
//               edge="start"
//               onClick={handleDrawerToggle}
//               sx={{ mr: 2 }}
//             >
//               <MenuIcon />
//             </IconButton>
//             <Typography
//               sx={{
//                 fontSize: "14px",
//                 fontWeight: 600,
//                 color: "#64748b",
//                 textTransform: "capitalize",
//                 fontFamily: "'Inter', sans-serif",
//               }}
//             >
//               {location.pathname.split("/").pop().replace("-", " ")}
//             </Typography>
//           </Box>

//           <Box sx={{ display: "flex", alignItems: "center", gap: 2.5 }}>
//             <IconButton size="small" sx={{ color: "#64748b" }}>
//               <Bell size={20} />
//             </IconButton>
//             <Divider orientation="vertical" flexItem sx={{ my: 2 }} />
//             <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//               <Box
//                 sx={{
//                   textAlign: "right",
//                   display: { xs: "none", md: "block" },
//                 }}
//               >
//                 <Typography
//                   sx={{ fontSize: "13px", fontWeight: 700, lineHeight: 1 }}
//                 >
//                   {username}
//                 </Typography>
//                 <Typography
//                   sx={{ fontSize: "11px", color: "#3b82f6", fontWeight: 600 }}
//                 >
//                   Staff User
//                 </Typography>
//               </Box>
//               <Avatar
//                 sx={{
//                   width: 36,
//                   height: 36,
//                   bgcolor: "#3b82f6",
//                   fontSize: "14px",
//                   fontWeight: 700,
//                   border: "2px solid #fff",
//                   boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//                 }}
//               >
//                 {username.charAt(0).toUpperCase()}
//               </Avatar>
//             </Box>
//           </Box>
//         </Toolbar>
//       </AppBar>

//       <Box
//         component="nav"
//         sx={{
//           width: { sm: currentWidth },
//           flexShrink: { sm: 0 },
//           transition: "width 0.3s",
//         }}
//       >
//         <Drawer
//           variant="temporary"
//           open={mobileOpen}
//           onClose={handleDrawerToggle}
//           ModalProps={{ keepMounted: true }}
//           sx={{
//             display: { xs: "block", sm: "none" },
//             "& .MuiDrawer-paper": {
//               width: drawerWidth,
//               boxSizing: "border-box",
//               border: "none",
//             },
//           }}
//         >
//           {drawer}
//         </Drawer>

//         <Drawer
//           variant="permanent"
//           sx={{
//             display: { xs: "none", sm: "block" },
//             "& .MuiDrawer-paper": {
//               width: currentWidth,
//               boxSizing: "border-box",
//               border: "none",
//               transition: "width 0.3s",
//               overflowX: "hidden",
//               ...visibleScrollbar,
//             },
//           }}
//           open
//         >
//           {drawer}
//         </Drawer>
//       </Box>

//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: { xs: 3, sm: 5 },
//           width: { xs: "100%", sm: `calc(100% - ${currentWidth}px)` },
//           mt: "64px",
//           transition: "margin 0.3s, width 0.3s",
//         }}
//       >
//         <Outlet />
//       </Box>
//     </Box>
//   );
// }

import React, { useEffect, useState } from "react";
import { Outlet, NavLink, useNavigate, useLocation } from "react-router-dom";
import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Avatar,
  Divider,
  useTheme,
  useMediaQuery,
  Menu,
  MenuItem,
} from "@mui/material";
import logo from "./logo.png";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import { Api } from "../Api/Api";
import {
  LayoutDashboard,
  UserPlus,
  UserCheck,
  UserX,
  Contact2,
  Wallet,
  HandCoins,
  BadgeDollarSign,
  Receipt,
  StickyNote,
  Bell,
  Settings2
} from "lucide-react";

const drawerWidth = 260;
const collapsedWidth = 85;

const visibleScrollbar = {
  overflowY: "auto",
  "&::-webkit-scrollbar": { width: "6px" },
  "&::-webkit-scrollbar-track": { background: "transparent" },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "rgba(148,163,184,0.4)",
    borderRadius: "8px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "rgba(148,163,184,0.7)",
  },
  scrollbarWidth: "thin",
  scrollbarColor: "rgba(148,163,184,0.6) transparent",
};

const sidebarItems = [
  {
    section: "OVERVIEW",
    items: [
      {
        title: "Dashboard",
        href: "/staff/dashboard2",
        icon: <LayoutDashboard size={18} />,
      },
      {
        title: "Master List",
        href: "/staff/list",
        icon: <Contact2 size={18} />,
      },
      {
        title: "Attendance Management",
        href: "/staff/attendance",
        icon: <Settings2 size={18} />,
      },
    ],
  },
  {
    section: "USER MANAGEMENT",
    items: [
      {
        title: "Active Customers",
        href: "/staff/customers",
        icon: <UserCheck size={18} />,
      },
      {
        title: "Pending",
        href: "/staff/pending",
        icon: <UserPlus size={18} />,
      },
      {
        title: "Closed Accounts",
        href: "/staff/closed",
        icon: <UserX size={18} />,
      },
      {
        title: "Staff Notes",
        href: "/staff/notes",
        icon: <StickyNote size={18} />,
      },
    ],
  },
  {
    section: "FINANCIALS",
    items: [
      {
        title: "Payments",
        href: "/staff/payments",
        icon: <Wallet size={18} />,
      },
      {
        title: "Advance Given",
        href: "/staff/advance",
        icon: <HandCoins size={18} />,
      },
      {
        title: "Principal Amount",
        href: "/staff/original",
        icon: <BadgeDollarSign size={18} />,
      },
      {
        title: "Daily Expenses",
        href: "/staff/expenses",
        icon: <Receipt size={18} />,
      },
    ],
  },
];

export default function StaffLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  

  const [mobileOpen, setMobileOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [username, setUsername] = useState("Staff");

  // State for the Profile Menu
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // useEffect(() => {
  //   const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  //   setUsername(currentUser.username || "Staff");

  //   if (!currentUser || currentUser.role !== "staff") {
  //     navigate("/", { replace: true });
  //   } else {
  //     setUsername(currentUser.username || "Staff");
  //   }
  // }, [navigate]);

  useEffect(() => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));

    if (!currentUser || currentUser.role !== "staff") {
      navigate("/", { replace: true });
      return;
    }

    setUsername(currentUser.username || "Staff");

    // 🔥 AUTO LOGOUT CHECK
    const interval = setInterval(async () => {
      try {
        const res = await fetch(`${Api}api/check-user.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userId: currentUser.userId }),
        });

        const data = await res.json();

        if (!data.status) {
          localStorage.removeItem("currentUser");
          alert("Your access has been revoked by admin.");
          navigate("/", { replace: true });
        }
      } catch (err) {
        console.log("Check failed");
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("currentUser");
    navigate("/", { replace: true });
  };

  const handleDrawerToggle = () => {
    if (isMobile) {
      setMobileOpen(!mobileOpen);
    } else {
      setIsCollapsed(!isCollapsed);
    }
  };

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileClose = () => {
    setAnchorEl(null);
  };

  const currentWidth = isMobile
    ? drawerWidth
    : isCollapsed
      ? collapsedWidth
      : drawerWidth;

  const drawer = (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        bgcolor: "#0f172a",
        color: "#f8fafc",
      }}
    >
      <Toolbar sx={{ px: isCollapsed && !isMobile ? 2 : 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box
            component="img"
            src={logo}
            alt="Logo"
            sx={{
              width: 150,
              height: 150,
              objectFit: "contain",
              borderRadius: 1,
            }}
          />
          {(!isCollapsed || isMobile) && (
            <Typography
              sx={{
                fontWeight: 800,
                fontSize: "1.1rem",
                letterSpacing: "-0.5px",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              Staff<span style={{ color: "#3b82f6" }}>ERP</span>
            </Typography>
          )}
        </Box>
      </Toolbar>

      <Box sx={{ flex: 1, px: 2, py: 3, ...visibleScrollbar }}>
        {sidebarItems.map((group) => (
          <Box key={group.section} sx={{ mb: 3 }}>
            {(!isCollapsed || isMobile) && (
              <Typography
                sx={{
                  fontSize: "10px",
                  color: "#64748b",
                  fontWeight: 700,
                  mb: 1.5,
                  ml: 2,
                  letterSpacing: "1.2px",
                  fontFamily: "'Inter', sans-serif",
                  textTransform: "uppercase",
                }}
              >
                {group.section}
              </Typography>
            )}
            <List sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              {/* {group.items.map((item) => ( */}
              {group.items
                .filter((item) => {
                  // Only SAL003 can see Attendance Management
                  if (
                    item.title === "Attendance Management" &&
                    username !== "SAL003"
                  ) {
                    return false;
                  }
                  return true;
                })
                .map((item) => (
                  <ListItem key={item.href} disablePadding>
                    <ListItemButton
                      component={NavLink}
                      to={item.href}
                      onClick={() => isMobile && setMobileOpen(false)}
                      sx={{
                        borderRadius: "8px",
                        py: 1,
                        px: isCollapsed && !isMobile ? 1.5 : 2,
                        justifyContent:
                          isCollapsed && !isMobile ? "center" : "flex-start",
                        color: "#94a3b8",
                        "&.active": {
                          bgcolor: "rgba(59, 130, 246, 0.1)",
                          color: "#3b82f6",
                          "& .MuiListItemIcon-root": { color: "#3b82f6" },
                        },
                        "&:hover": {
                          bgcolor: "rgba(255,255,255,0.03)",
                          color: "#f8fafc",
                        },
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          color: "inherit",
                          minWidth: isCollapsed && !isMobile ? 0 : 32,
                        }}
                      >
                        {item.icon}
                      </ListItemIcon>
                      {(!isCollapsed || isMobile) && (
                        <ListItemText
                          primary={item.title}
                          primaryTypographyProps={{
                            fontSize: "13.5px",
                            fontWeight: 500,
                            fontFamily: "'Inter', sans-serif",
                          }}
                        />
                      )}
                    </ListItemButton>
                  </ListItem>
                ))}
            </List>
          </Box>
        ))}
      </Box>
    </Box>
  );

  return (
    <Box
      sx={{
        display: "flex",
        bgcolor: "#f1f5f9",
        minHeight: "100vh",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <CssBaseline />

      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          width: { sm: `calc(100% - ${currentWidth}px)` },
          ml: { sm: `${currentWidth}px` },
          bgcolor: "rgba(255, 255, 255, 0.8)",
          backdropFilter: "blur(8px)",
          borderBottom: "1px solid #e2e8f0",
          color: "#1e293b",
          transition: theme.transitions.create(["width", "margin"], {
            duration: 300,
          }),
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between", minHeight: "64px" }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton
              color="inherit"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#64748b",
                textTransform: "capitalize",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              {location.pathname.split("/").pop().replace("-", " ")}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {/* <IconButton size="small" sx={{ color: "#64748b", mr: 1 }}>
              <Bell size={20} />
            </IconButton> */}

            <Divider orientation="vertical" flexItem sx={{ my: 2, mr: 1 }} />

            {/* Clickable Profile Trigger */}
            <Box
              onClick={handleProfileClick}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                cursor: "pointer",
                padding: "6px 12px",
                borderRadius: "10px",
                transition: "all 0.2s ease",
                "&:hover": {
                  bgcolor: "rgba(59, 130, 246, 0.05)",
                  transform: "translateY(-1px)",
                },
              }}
            >
              <Box
                sx={{
                  textAlign: "right",
                  display: { xs: "none", md: "block" },
                }}
              >
                <Typography
                  sx={{
                    fontSize: "13px",
                    fontWeight: 700,
                    color: "#1e293b",
                    lineHeight: 1,
                    fontFamily: "'Inter', sans-serif",
                  }}
                >
                  {username}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "11px",
                    color: "#3b82f6",
                    fontWeight: 600,
                    mt: 0.5,
                    fontFamily: "'Inter', sans-serif",
                  }}
                >
                  Staff User
                </Typography>
              </Box>
              <Avatar
                sx={{
                  width: 38,
                  height: 38,
                  bgcolor: "#3b82f6",
                  fontSize: "15px",
                  fontWeight: 700,
                  border: "2px solid #fff",
                  boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                }}
              >
                {username.charAt(0).toUpperCase()}
              </Avatar>
            </Box>

            {/* Logout Dropdown Menu */}
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleProfileClose}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              PaperProps={{
                elevation: 0,
                sx: {
                  mt: 1.5,
                  overflow: "visible",
                  filter: "drop-shadow(0px 10px 15px -3px rgba(0,0,0,0.1))",
                  borderRadius: "12px",
                  minWidth: "160px",
                  border: "1px solid #e2e8f0",
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
            >
              <MenuItem
                onClick={handleLogout}
                sx={{
                  mx: 1,
                  my: 0.5,
                  borderRadius: "8px",
                  color: "#ef4444",
                  fontWeight: 600,
                  fontSize: "13.5px",
                  fontFamily: "'Inter', sans-serif",
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  py: 1.2,
                  "&:hover": {
                    bgcolor: "#fef2f2",
                    color: "#dc2626",
                  },
                }}
              >
                <LogoutIcon size={18} />
                Logout Session
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      <Box
        component="nav"
        sx={{
          width: { sm: currentWidth },
          flexShrink: { sm: 0 },
          transition: "width 0.3s",
        }}
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              border: "none",
            },
          }}
        >
          {drawer}
        </Drawer>

        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              width: currentWidth,
              boxSizing: "border-box",
              border: "none",
              transition: "width 0.3s",
              overflowX: "hidden",
              ...visibleScrollbar,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 3, sm: 5 },
          width: { xs: "100%", sm: `calc(100% - ${currentWidth}px)` },
          mt: "64px",
          transition: "margin 0.3s, width 0.3s",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}